class DiscountCode extends HTMLElement {
  constructor() {
    super();
    this.couponCode = this.querySelector('#coupon-code');
    this.applyBtn = this.querySelector('#apply-coupon');
    this.removeBtn = this.querySelector('#remove-coupon');
    this.checkoutBtn = document.querySelector('.cart__checkout-button');
    this.cartAttributes = this.getAttribute('data-attributes');

    this.eventListeners();
  }

  eventListeners() {

    const self = this;
    this.couponCode.addEventListener('input', function() {
      self.applyBtn.classList.remove('hidden');
    });

    this.couponCode.addEventListener('blur', function() {
      if(this.value == "") { self.applyBtn.classList.add('hidden'); }
    });

    this.applyBtn.addEventListener('click', this.applyCoupon.bind(this));

    this.removeBtn.addEventListener('click', async () => {
      const coupon = document.querySelector('.coupon-applied').innerText;

      const dialog = new ConfirmDialog({
        dialogTitle: window.cartStrings.remove,
        bodyText: "<p>" + window.cartStrings.remove_text + "</p><span>" + coupon + "</span>",
        trueButtonText: window.cartStrings.trueButtonText ,
        falseButtonText: window.cartStrings.falseButtonText
      });

      const shoudRemoveCoupon = await dialog.confirm();
      if (shoudRemoveCoupon) {
        this.removeCoupon();
      }

    });
  }
  
  async applyCoupon(event) {
    const discountCode = this.couponCode.value;
    if(!document.getElementById('cart-privacy').checked) {
      document.querySelector('.cart__privacy').classList.add('field--with-error');
      return;
    }
    if (discountCode != "") {
      const result = await this.setCartAttributes({ discount_code : discountCode });

      if(result) {
        this.removeBtn.classList.remove('hidden');
        this.applyBtn.classList.add('hidden');
        window.location = window.location.origin + "/checkout?discount=" + discountCode;
        // window.location = window.location.origin + "/discount/" + discountCode + "?redirect=/cart";
      }
    }
  }

  async removeCoupon() {
    const result = await this.setCartAttributes({ discount_code: '', discount: 'false' });
    if(result) {
      window.location = window.location.origin + "/checkout?discount=none";
    }
  }

  setCartAttributes(attributes = {}) {
    return new Promise((resolve, reject) => {
      const body = JSON.stringify({
        attributes: attributes
      });

      fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          resolve(true);
        }).catch((error) => {
          console.log(error);
          redirect(error);
        });
    });
  }


}
customElements.define('discount-code', DiscountCode);